"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoFilled = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.VideoFilled = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M2.25 2C1.55964 2 1 2.55964 1 3.25V12.75C1 13.4404 1.55964 14 2.25 14H13.75C14.4404 14 15 13.4404 15 12.75V3.25C15 2.55964 14.4404 2 13.75 2H2.25ZM10.2526 8.43271C10.5852 8.24013 10.5852 7.75987 10.2526 7.56729L7.00052 5.68451C6.66719 5.49153 6.25 5.73206 6.25 6.11722V9.88278C6.25 10.2679 6.66719 10.5085 7.00052 10.3155L10.2526 8.43271Z", fill: colors[0], fillRule: "evenodd", clipRule: "evenodd" }));
    },
    name: 'video_filled',
    defaultColors: ['#D9D9D9'],
    colorful: false,
    allPathData: ['M2.25 2C1.55964 2 1 2.55964 1 3.25V12.75C1 13.4404 1.55964 14 2.25 14H13.75C14.4404 14 15 13.4404 15 12.75V3.25C15 2.55964 14.4404 2 13.75 2H2.25ZM10.2526 8.43271C10.5852 8.24013 10.5852 7.75987 10.2526 7.56729L7.00052 5.68451C6.66719 5.49153 6.25 5.73206 6.25 6.11722V9.88278C6.25 10.2679 6.66719 10.5085 7.00052 10.3155L10.2526 8.43271Z'],
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
});
